export const validateSchedule = ({ step }) => {
  const args = step?.arguments;

  if (args?.days?.length === 0) {
    return { status: 'setup', message: 'Set days' };
  }

  if (args?.scheduleType === 'interval' && !args?.interval) {
    return { status: 'setup', message: 'Set interval' };
  }

  if (args?.scheduleType === 'fixed' && args?.runTimes?.length === 0) {
    return { status: 'setup', message: 'Set run times' };
  }

  return { status: 'valid' };
};
